module.exports = __webpack_public_path__ + "img/logo_square_union_chain.4640ca17.png";